<template>
  <div class="personal-center-wrap">
    <h1 class="page-title">个人中心</h1>

    <!-- 顶部Tab导航 - 数组循环渲染 -->
    <a-tabs v-model:activeKey="activeTab" class="center-tabs">
      <a-tab-pane
        v-for="tabItem in tabList"
        :key="tabItem.key"
        :tab="tabItem.label"
      />
    </a-tabs>

    <!-- 子页面组件切换 -->
    <RightsPage v-show="activeTab === 'rights'" :user-info="userInfo" :rights-list="rightsList" @save-avatar="handleSaveAvatar" />
    <InfoPage v-show="activeTab === 'info'" :user-info="userInfo" @save-info="handleSaveInfo" @upload-avatar="handleSaveAvatar" />
    <PwdPage v-show="activeTab === 'pwd'" @modify-pwd="handleModifyPwd" />
    <FeedbackPage v-show="activeTab === 'feedback'" @submit-feed="handleSubmitFeed" />
  </div>
</template>

<script setup>
import { ref, defineOptions } from 'vue'
import { message } from 'ant-design-vue'

defineOptions({ name: 'PersonalCenter' })
// 导入4个子组件
import RightsPage from '@/components/personal/RightsPage.vue'
import InfoPage from '@/components/personal/InfoPage.vue'
import PwdPage from '@/components/personal/PwdPage.vue'
import FeedbackPage from '@/components/personal/FeedbackPage.vue'

// Tab 配置数组
const tabList = ref([
  { key: 'rights', label: '权益中心' },
  { key: 'info', label: '个人资料' },
  { key: 'pwd', label: '密码设置' },
  { key: 'feedback', label: '使用反馈' },
])

// Tab激活key，默认选中第一项
const activeTab = ref(tabList.value[0].key)

// 用户基础信息
const userInfo = ref({
  nickname: '安妮控',
  phone: '15290055751',
  avatar: '',
  svipDate: '2026-07-20'
})

// 权益列表
const rightsList = ref([
  { id:1, name:'AI法律检索', used:0, left:0, unlimit:false, color:'#e6f7ff', icon: require('@/assets/perasonal/icon1.png') },
  { id:2, name:'AI法律研究', used:0, left:0, unlimit:false, color:'#f0f7ff', icon: require('@/assets/perasonal/icon2.png') },
  { id:3, name:'AI合同审查', used:0, left:0, unlimit:false, color:'#f5f7fa', icon: require('@/assets/perasonal/icon3.png') },
  { id:4, name:'超级文件助手', used:0, left:0, unlimit:false, color:'#f0f8ff', icon: require('@/assets/perasonal/icon4.png') },
  { id:5, name:'AI文书起草', used:0, left:0, unlimit:false, color:'#eff6ff', icon: require('@/assets/perasonal/icon5.png') },
  { id:6, name:'极简尽调', used:0, left:0, unlimit:false, color:'#f3f0ff', icon: require('@/assets/perasonal/icon6.png') },
  { id:7, name:'文件脱敏', used:0, left:0, unlimit:false, color:'#e6fffb', icon: require('@/assets/perasonal/icon7.png') },
  { id:8, name:'法律翻译', used:0, left:0, unlimit:false, color:'#fff7e6', icon: require('@/assets/perasonal/icon8.png') },
  { id:9, name:'AI法律检索', used:0, left:0, unlimit:false, color:'#fff7e6', icon: require('@/assets/perasonal/icon9.png') },
  { id:10, name:'案例法规数据库', used:0, left:0, unlimit:true, color:'#f0fff4', icon: require('@/assets/perasonal/icon10.png') },
  { id:11, name:'AI法律检索', used:0, left:0, unlimit:false, color:'#fff1f0', icon: require('@/assets/perasonal/icon11.png') },
  { id:12, name:'企业查询', used:0, left:0, unlimit:false, color:'#fff7e6', icon: require('@/assets/perasonal/icon12.png') },
])

// 事件处理 - 头像上传
const handleSaveAvatar = (file) => {
  message.info('头像上传接口待对接', file)
}
// 保存个人资料
const handleSaveInfo = (form) => {
  // message.success('资料保存成功')
  userInfo.value.nickname = form.nickname
}
// 修改密码
const handleModifyPwd = () => {
}
// 提交反馈
const handleSubmitFeed = () => {
  message.success('反馈提交成功，我们会尽快处理')
}
</script>

<style scoped lang="less">
.personal-center-wrap {
  padding: 24px;
  background: #f7f9fc;
  min-height: 100vh;
  box-sizing: border-box;
}
.page-title {
  font-size: 32px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 20px;
}
.center-tabs {
  background: #fff;
  padding: 0 24px;
  border-radius: 12px;
  // margin-bottom: 20px;
}
</style>